import React, { useState } from 'react';
import { ProjectCard } from './ProjectCard';
import { ProjectModal, Project } from './ProjectModal';
import { useLanguage } from '../contexts/LanguageContext';
const PROJECT_META = [{
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/982e803e-e802-4400-9885-d8d5531ee756.jpg',
  slug: 'maestro-del-oficio.com',
  url: 'https://maestro-del-oficio.com'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/3193ea05-2fe8-42b3-a484-b6c08e28f2e6.jpg',
  slug: 'direccion-exclusiva.com',
  url: 'https://direccion-exclusiva.com'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d76d19f0-e613-4684-8eb0-611123c906e9.jpg',
  slug: 'estandar-emergencia.com',
  url: 'https://estandar-emergencia.com'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/12e22d1b-091d-41de-b07d-9c9652505549.jpg',
  slug: 'el-santuario.com',
  url: 'https://el-santuario.com'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d48513be-cf41-4a7d-bdc8-a1dc930cb729.jpg',
  slug: 'mano-confiable.com',
  url: 'https://mano-confiable.com'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/cdb0f10f-94df-40c6-a542-80e52a775384.jpg',
  slug: 'consejo-confianza.com',
  url: 'https://consejo-confianza.com'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d99119c9-bdff-44d3-addc-0c59e73b392f.jpg',
  slug: 'atelier-fuerza.com',
  url: 'https://atelier-fuerza.com'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/f2a07a47-e5dd-4430-bab1-09c53c6c1a56.jpg',
  slug: 'clinica-familiar.com',
  url: 'https://clinica-familiar.com'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/38ae45e9-65fe-444d-acf1-73c454f39c56.jpg',
  slug: 'coleccion-privada.com',
  url: 'https://coleccion-privada.com',
  fullWidth: true
}];
export function Portfolio() {
  const {
    t
  } = useLanguage();
  const [activeProject, setActiveProject] = useState<Project | null>(null);
  const projects: (Project & {
    fullWidth?: boolean;
  })[] = PROJECT_META.map((meta, index) => ({
    caseNumber: String(index + 1).padStart(2, '0'),
    ...t.projects[index],
    ...meta
  }));
  return <section id="portafolio" className="bg-kinetic-bg py-16 md:py-24 px-5 sm:px-6" data-id="element-193" data-mp="18xcjo85k3ubw">
      <div className="container mx-auto" data-id="element-194" data-mp="26kcqc5pvjo02">
        <span className="inline-flex items-center text-xs text-cyan-400 uppercase tracking-widest" data-id="element-195" data-mp="26ja265jxrznu">
          <span className="w-2 h-2 rounded-full bg-cyan-400 inline-block mr-2 animate-pulse-dot" data-id="element-196" data-mp="21n338wpyjofe" />
          {t.portfolio_label}
        </span>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 sm:gap-6 mt-4" data-id="element-197" data-mp="1rvoz2bn2a0fx">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-black text-white max-w-lg" data-id="element-198" data-mp="2pb2pbjcbqqnn">
            {t.portfolio_heading}
          </h2>
          <p className="text-white/50 text-sm sm:text-base max-w-sm" data-id="element-199" data-mp="2khrhpfzou5uo">{t.portfolio_intro}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 mt-10 sm:mt-16" data-id="element-200" data-mp="2rx3fd8ny4f9v">
          {projects.map(project => <ProjectCard key={project.caseNumber} {...project} onOpen={setActiveProject} data-id="element-201" data-mp="31snc1xac3hzo" />)}
        </div>
      </div>

      {activeProject && <ProjectModal project={activeProject} onClose={() => setActiveProject(null)} data-id="element-202" data-mp="36tktu8rfma0n" />}
    </section>;
}